import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Breadcrumb, Flex, Tabs, Button, Skeleton } from "antd";
import TabClientsLeads from "./TabClientsLeads";
import TabPermissionsWealthAdvisor from "../../../../../super_admin/page/PageUsers/component/SectionUserPermission/component/TabPermissionsWealthAdvisor";

import StyledContainer from "./style";

import { setPhoneMask } from "../../../../../../../../utils/helper/general";

import { faPenToSquare } from "@fortawesome/free-regular-svg-icons";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as DotSeparator } from "../../../../image/dot_separator.svg";

const SectionDetailsAdvisor = ({
  disableEdit,
  getUserData,
  handleActionClientArchive,
  handleActionClientTransfer,
  handleBreadcrumbClick,
  handleEditActiveClient,
  handleOpenManagedUser,
  handleProposalView,
  handleUserNameClick,
  handleViewFolders,
  submitPermissions,
}) => {
  const [loading, setLoading] = useState(true);
  const [clientData, setClientData] = useState();

  useEffect(() => {
    setLoading(true);

    getUserData()
      .then(setClientData)
      .finally(() => setLoading(false));
  }, []);

  const items = [
    {
      children: (
        <TabClientsLeads
          handleActionClientArchive={handleActionClientArchive}
          handleActionClientTransfer={handleActionClientTransfer}
          handleProposalView={handleProposalView}
          handleUserNameClick={handleUserNameClick}
          disableEdit={disableEdit}
          loading={loading}
          managerData={clientData}
        />
      ),
      hidden: true,
      key: "clientsLeads",
      label: "Clients & Leads",
    },
    {
      children: (
        <TabPermissionsWealthAdvisor
          allowEdit
          clientPermissions={clientData?.permissions}
          handleSave={submitPermissions}
          handleViewFolders={handleViewFolders}
          loading={loading}
        />
      ),
      key: "permissions",
      label: "Advisor Permissions",
    },
  ].filter(it => !it.hidden);

  return (
    <Skeleton active loading={loading} style={{ padding: "16px 32px" }}>
      <StyledContainer>
        <Breadcrumb
          items={[
            {
              onClick: handleBreadcrumbClick,
              title: (
                <Flex align="center" gap={8} style={{ cursor: "pointer" }}>
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    style={{ fontSize: 14 }}
                  />
                  <b>People</b>
                </Flex>
              ),
            },
            {
              title: <b>Advisors</b>,
            },
            {
              title: <span style={{ color: "#8e8c8c" }}>User Profile</span>,
            },
          ]}
          separator={<DotSeparator style={{ color: "#C9C8C8" }} />}
        />

        <header>
          <Flex gap={4} vertical>
            <Flex justify="space-between">
              <Flex align="center" gap={16}>
                <h2>
                  {clientData?.personalInfo?.firstName}{" "}
                  {clientData?.personalInfo?.lastName}
                </h2>
                <Button
                  icon={<FontAwesomeIcon icon={faPenToSquare} />}
                  onClick={handleEditActiveClient}
                  shape="round"
                  size="small"
                  style={{ height: 28, minHeight: 28 }}
                />
              </Flex>

              <Button
                onClick={() => handleOpenManagedUser(clientData?._id)}
                shape="round"
                size="small"
                style={{
                  background: "#DBE245",
                  fontWeight: 800,
                }}
              >
                Launch
              </Button>
            </Flex>

            <Flex align="center" gap={8}>
              {clientData?.company?.name}
              <DotSeparator />
              Advisor
              <DotSeparator />
              {clientData?._id}
              <DotSeparator />
              {setPhoneMask(clientData?.personalInfo?.phoneNumber)}
            </Flex>
          </Flex>
        </header>

        <Tabs items={items} />
      </StyledContainer>
    </Skeleton>
  );
};

export default SectionDetailsAdvisor;
